import { EMPTY_ROOT_CONTAINER_PROPS } from "@client/content/lib/consts";
import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import {
  createComment as createCommentMemberDetails,
  hideAddCommentModal as hideAddCommentMemberModalDetails
} from "../../../MemberOrders/actions";
import {
  createComment as createCommentDetails,
  hideAddCommentModal as hideAddCommentModalDetails
} from "../../../OrderDetail/actions";
import { DUMMY_ORDER } from "../../lib";
import { localStateSelector } from "../../selectors";
import { type OrderConfirmation } from "../../types";
import Component, { type ActionProps, type MapProps, type ModalData } from "./component";

const INVISIBLE_PROPS: MapProps = {
  ...EMPTY_ROOT_CONTAINER_PROPS,
  error: null,
  orderId: "",
  isVisible: false,
  isDetail: false
};

type Props = RootContainerProps & {
  detail?: OrderConfirmation.Api.OrderSummary;
  isModal: boolean;
};
const makeMapStateToProps = () => {
  return (state: AppState, props: Props): MapProps => {
    const localState = localStateSelector(state, props);
    if (!localState.isAddCommentVisible) return INVISIBLE_PROPS;

    return {
      ...props,
      error: localState.error,
      isDetail: props.isModal,
      isVisible: true,
      orderId: (props.detail ?? localState.orderSummary ?? DUMMY_ORDER).order.orderId
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: Props): ActionProps => ({
  onClose: () =>
    dispatch(
      props.isModal
        ? hideAddCommentMemberModalDetails(getEntityRef(props))
        : hideAddCommentModalDetails(getEntityRef(props))
    ),
  onSubmit: (data: ModalData) =>
    dispatch(
      props.isModal
        ? createCommentMemberDetails({ id: props.id, source: props.source, comment: data.comment })
        : createCommentDetails({ id: props.id, source: props.source, comment: data.comment })
    )
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
